import React, { useEffect, useState } from "react";
import { Aboutsec1, Aboutsec2 } from "./components/Aboutcomponent";
import { Sec2, Sec3, Sec5 } from "./components/Homecomponent";
import PageHeader from "./components/PagesHeaderComponent/PageHeader";
import newsImg from "../assets/images/newsImg.png"
import newsImg2 from "../assets/images/newsImg2.png"
import notificationImg from "../assets/images/notification.png"
import { Button, Card, Container, Col, Row, Badge } from "react-bootstrap";
import { useNavigate } from "react-router-dom/dist";
import "swiper/css";
import "swiper/css/navigation";
import { Button as AntButton, Dropdown, Input, Menu, Pagination, Tabs } from "antd";
import { FreeMode, Navigation, Thumbs } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import PageHeaderWithRoutes from "./components/PagesHeaderComponent/PageHeaderWithRoute";
import RegulatoryIcon from "../assets/images/icons/regulatory_info_icon.png"
import ResourceIcon from "../assets/images/icons/useful_resource_icon.png"
import NewsFeedIcon from "../assets/images/icons/newsfeed_icon.png"
import InnerHeading from "./components/InnerHeading/InnerHeading";
import { Box, LinearProgress, Tooltip } from "@mui/material";
import CoreHttpHandler from "../http/services/CoreHttpHandler";
import CustomTextLimit from "../assets/global-components/TextLimit";
import ReportIcon from "../assets/images/icons/report.png"


const NewsFeeds = () => {
	const navigate = useNavigate();
	const [news, setNews] = useState([]);
	const [allNews, setAllNews] = useState([]);
	const [isLoading, setIsLoading] = useState(false);
	const [activeTab, setActiveTab] = useState("Governance");
	const [currentPage, setCurrentPage] = useState(1);
	const [searchTitle, setSearchTitle] = useState("");
	const [selectedOrder, setSelectedOrder] = useState("DESC");
	const pageSize = 6;

	const getNews = () => {
		setIsLoading(true)
		CoreHttpHandler.request(
			"library",
			"fetchGovNews",
			{
				"type": "governance_news",
				"status": "true",
				"limit": 10000,
				"page": 1
			},
			(res) => {
				setAllNews(res.data.data.news?.news)
				setIsLoading(false)
			},
			(err) => {
				setIsLoading(false)
			}
		);
	};

	const filterNews = () => {
		let filtered = allNews;

		if (searchTitle) {
			filtered = filtered.filter(item =>
				item.title?.toLowerCase().includes(searchTitle.toLowerCase())
			);
		}

		const sorted = [...filtered].sort((a, b) =>
			selectedOrder === "ASC"
				? a.id - b.id
				: b.id - a.id
		);

		setNews(sorted);
		setCurrentPage(1);
	};

	const handleOrderMenuClick = (e) => {
		setSelectedOrder(e.key);
	};

	const clearSearch = () => {
		setSearchTitle("");
		setSelectedOrder("DESC");
		setNews(allNews);
		setCurrentPage(1);
	};

	const orderMenu = (
		<Menu onClick={handleOrderMenuClick}>
			<Menu.Item key={"ASC"}>ASC</Menu.Item>
			<Menu.Item key={"DESC"}>DESC</Menu.Item>
		</Menu>
	);

	const paginatedNews = news.slice(
		(currentPage - 1) * pageSize,
		currentPage * pageSize
	);




	const handleBtnClick = (data) => {
		navigate(`/Library/NewsFeeds/${data.id}`, {
			state: {
				...data,
			},
		});
	}

	let headerData = [{
		name: "Regulatory Information",
		route: "/Library/Legal&RegulatoryInformation",
		imgSrc: RegulatoryIcon
	}, {
		name: "Resources",
		route: "/Library/UsefulResources",
		imgSrc: ResourceIcon
	}, {
		name: "News Feed",
		route: "/Library/NewsFeeds",
		imgSrc: NewsFeedIcon

	}, {
		name: "Reports",
		route: "/Library/UsefulResources/REPORTS",
		imgSrc: ReportIcon

	}
	]

	useEffect(() => {
		getNews();
	}, [activeTab])

	useEffect(() => {
		filterNews();
	}, [allNews])

	return (
		<>
			{/* <PageHeader heading="News Feeds" /> */}
			<PageHeaderWithRoutes tabs={headerData} heading="Corporate Governance Library" desc="Discover our comprehensive library—a vital resource hub of legal and regulatory information, resources, and news essential for shareholders. Explore our extensive repository to stay informed with the latest updates and news feeds relevant to corporate governance." />

			<div className="content_wrap">

				<section className='newsFeeds'>
					<div className='container'>

						{/* <div> */}
						<div className="cards_wrap">
							<Container>
								<Row>
									<InnerHeading heading="News Feed" text="Stay informed about your rights as a shareholder and exercise your rights in the best interest of your role as a responsible shareholder!" />

									<Col xs={12} style={{ animation: "fadeInUp 0.5s ease both" }}>
										<Row className="d-flex align-items-center justify-content-center mb-4">
											<Col lg={5} md={5} xs={12} style={{ marginBottom: "10px" }}>
												<Input
													value={searchTitle}
													style={{ width: "100%", borderRadius: "20px", padding: "8px 15px", transition: "all 0.3s ease", border: "1px solid #d9d9d9" }}
													onFocus={(e) => e.target.style.boxShadow = "0 0 0 3px rgba(7,88,143,0.1)"}
													onBlur={(e) => e.target.style.boxShadow = "none"}
													onChange={(e) => setSearchTitle(e.target.value)}
													placeholder="Search by Title"
												/>
											</Col>
											<Col lg={2} md={2} xs={4} style={{ marginBottom: "10px" }}>
												<Dropdown overlay={orderMenu} trigger={['click']}>
													<AntButton
														style={{ width: "100%", borderRadius: "20px", padding: "0 15px", height: "36px", transition: "all 0.3s ease" }}
														onMouseEnter={(e) => { e.currentTarget.style.borderColor = "#07588f"; e.currentTarget.style.color = "#07588f"; }}
														onMouseLeave={(e) => { e.currentTarget.style.borderColor = "#d9d9d9"; e.currentTarget.style.color = "rgba(0,0,0,0.85)"; }}
													>
														Sort: {selectedOrder} ▼
													</AntButton>
												</Dropdown>
											</Col>
											<Col lg={3} md={3} xs={8} style={{ marginBottom: "10px", display: "flex", gap: "8px" }}>
												<AntButton
													style={{ background: "#07588f", color: "#fff", border: "none", flex: 1, borderRadius: "20px", height: "36px", transition: "all 0.3s ease" }}
													onMouseEnter={(e) => { e.currentTarget.style.background = "#0a6ebd"; e.currentTarget.style.transform = "translateY(-2px)"; e.currentTarget.style.boxShadow = "0 4px 12px rgba(7,88,143,0.3)"; }}
													onMouseLeave={(e) => { e.currentTarget.style.background = "#07588f"; e.currentTarget.style.transform = "translateY(0)"; e.currentTarget.style.boxShadow = "none"; }}
													onClick={() => filterNews()}
												>
													Search
												</AntButton>
												<AntButton
													style={{ flex: 1, borderRadius: "20px", height: "36px", transition: "all 0.3s ease" }}
													onMouseEnter={(e) => { e.currentTarget.style.borderColor = "#07588f"; e.currentTarget.style.color = "#07588f"; e.currentTarget.style.transform = "translateY(-2px)"; }}
													onMouseLeave={(e) => { e.currentTarget.style.borderColor = "#d9d9d9"; e.currentTarget.style.color = "rgba(0,0,0,0.85)"; e.currentTarget.style.transform = "translateY(0)"; }}
													onClick={clearSearch}
												>
													Clear
												</AntButton>
											</Col>
										</Row>
									</Col>

									{/*
									<div className="tabs">
										<h5
											className={`tab-button ${activeTab === 'Governance' ? 'active' : ''}`}
											onClick={() => setActiveTab('Governance')}
										>
											Governance News
										</h5>
										<h5
											className={`tab-button ${activeTab === 'Company' ? 'active' : ''}`}
											onClick={() => setActiveTab('Company')}
										>
											Company Specific News
										</h5>
									</div>
									 */}

									{isLoading ?
										<Box sx={{ my: '5rem' }}>
											<LinearProgress color="success" />
										</Box>
										:
										paginatedNews.map((e, index) => (
											<Col lg={4} md={6}>
												<Card className="cards">
													<p className="creator_name">
														{e.creator_name}
													</p>
													<img alt="Education" variant="top" src={e.image} />
													<CustomTextLimit limit={50} title text={e.title} />
													<CustomTextLimit text={e.description} />
													<div className="card-content">
														<button onClick={() => window.open(e?.url?.startsWith('http') ? e.url : `https://${e.url}`, '_blank')} disabled={!e?.url} className="rounded_btn" variant="primary">Read More</button>
													</div>
												</Card>
											</Col>
										))
									}
								</Row>
							</Container>
							<Pagination
								total={news.length}
								current={currentPage}
								pageSize={pageSize}
								hideOnSinglePage
								onChange={(page) => setCurrentPage(page)} />
						</div>
					</div>
				</section>
			</div>

		</>
	);
};

export default NewsFeeds;
